// React
import React from "react"

// Utilities
import formatDate from "../../utils/formatDate"

// Material ui
import { Card, CardContent, Typography, Box } from "@mui/material"

export default function EventCard(props) {
  const [isHovering, setIsHovering] = React.useState(false)
  const { slug, title, summary, startTime, endTime, destinationUrl, subtitle } =
    props

  return (
    <a
      href={destinationUrl}
      style={{
        textDecoration: `none`,
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Card
        sx={{
          backgroundColor: `transparent`,
          border: `1px solid black`,
          borderColor: "borders",
          borderRadius: `0`,
          height: `100%`,
          boxShadow: 0,
          "&:hover": {
            cursor: "pointer",
          },
        }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <CardContent
          sx={{
            height: `100%`,
            display: `flex`,
            flexDirection: `column`,
            justifyContent: `space-between`,
          }}
        >
          <Box>
            <Typography
              sx={{
                marginTop: 1,
                marginBottom: 3,
                fontWeight: 500,
                color: "titles.main",
                textTransform: `uppercase`,
              }}
            >
              {formatDate(startTime)}
            </Typography>
            <Typography
              gutterBottom
              variant="h3"
              component="div"
              sx={{
                color: isHovering ? "primary.main" : `titles.main`,
                fontWeight: "bold",
                fontSize: `30px`,
                textTransform: `uppercase`,
                marginBottom: 0,
              }}
            >
              {title}
            </Typography>
            <Typography
              gutterBottom
              variant="windsorRegular"
              component="div"
              sx={{
                color: isHovering ? "primary.main" : `titles.main`,
                fontSize: `30px`,
                fontWeight: 400,
                textTransform: `uppercase`,
                marginBottom: 12,
              }}
            >
              {subtitle}
            </Typography>
          </Box>
          <Box
            sx={{
              display: `flex`,
              flexDirection: `column`,
              minHeight: `190px`,
              justifyContent: `space-between`,
            }}
          >
            <Typography
              variant="body2"
              color="text.main"
              sx={{
                marginBottom: 2,
              }}
            >
              {summary.summary}
            </Typography>
            <Typography
              variant="monoLink"
              sx={{
                marginTop: 2,
              }}
            >
              MORE INFO
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </a>
  )
}
